module.exports = __webpack_public_path__ + "static/media/191EE235.2cd9fb73.jpg";